module.exports = __webpack_public_path__ + "assets/img/logo.1be5de83.png";